export const CaseStatusColorCodeEnum = {
    'consult complete': '#de0365',
    'consult complete no rx': '#293191',
    'pending prescription': '#27adbf',
    'rx change': '#b4048a',
    'rx renewal': '#b44a2e',
    'rx renewal cancelled': '#fa30ce',
    'additional info required': '#0b19fe',
    'invalid face photo': '#2cef59',
    'invalid photo id': '#0a9ba9',
    'case created': '#f10ba6',
    'pending schedule': '#5da7a3',
    'cancelled': '#fa30ce',
    'assigned': 'green',
    'pending video consult': '#f95424',
    'pending audio consult': '#fa7cdc',
    'refer': '#335CFF',
}

export const CaseStatusEnum = {
    CONSULT_COMPLETE: 'consult complete',
    CONSULT_COMPLETE_NO_RX: 'consult complete no rx',
    ADDITIONAL_INFO_REQUIRED: 'additional info required',
    REFER: 'refer',
    PENDING_PRESCRIPTION: 'pending prescription',
    CASE_CREATED: 'case created',
    RX_CHANGE: 'rx change',
    INVALID_FACE_PHOTO: 'invalid face photo',
    INVALID_PHOTO_ID: 'invalid photo id',
    PENDING_SCHEDULE: 'pending schedule',
    PENDING_VIDEO_CONSULT: 'pending video consult',
    PENDING_AUDIO_CONSULT: 'pending audio consult',
    ARCHIVE: 'archive',
    CANCELLED: 'cancelled',
    ASSIGNED: 'assigned',
    RX_RENEWAL: 'rx renewal',
    WAITING_ROOM: 'waiting room',
    PENDING_LABS: 'pending labs',
    DELETE: 'delete',
}

export const REQUEST_STATUS = {
	PENDING: 'PENDING',
	COMPLETED: 'COMPLETED',
	COMPLETED_NO_RX: 'COMPLETED NO RX',
	CANCELED: 'CANCELED',
	PENDING_LAB_ORDER: 'PENDING LAB ORDER',
	PENDING_LAB_RESULTS: 'PENDING LAB RESULTS',
	PENDING_CONSULTATION: 'PENDING CONSULTATION'
}

export const CASE_TAGS = {
    NEEDS_REVIEW: '*needs review',
    REVIEWED: '*reviewed',
}

export const PHYSICIAN_TAGS = {
    NEEDS_REVIEW: 'needs review',
    REVIEWER: 'reviewer',
    LEAD_PHYSICIAN: 'lead physician',
}

export const BUTTON_SIZES = {
    MINI: 'mini',
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large'
}

export const BUTTON_COLORS = {
    DEFAULT: 'default',
    PRIMARY: 'primary',
    SUCCESS: 'success',
    WARNING: 'warning',
    DANGER: 'danger'
}

export const API_TYPES = {
    PHYSICIAN: 'physician',
    CASE: 'case',
    ADMIN: 'admin'
}

export const TEMPLATE_TYPES = {
    CUSTOM: 'custom',
    SHARED: 'shared',
    MY: 'my',
    ADMIN: 'admin'
}

export const PRESCRIPTION_STATUS = {
    QUEUED: 'queued',
    SUBMITTED: 'submitted',
    COMPLETED: 'completed',
    FAILED: 'failed'
}

export const MEDICATION_STATUS = {
    CANCEL_PENDING: 'CancelPending',
    CANCEL: 'Cancel',
    CANCELED: 'Canceled',
    DISCONTINUED: 'Discontinued',
    INACTIVE: 'Inactive',
    CANCEL_REQUESTED: 'CancelRequested',
    CANCEL_DENIED: 'CancelDenied'
}

export const PHARMACY_STATUS = {
    READY_TO_SIGN: 'ReadyToSign',
    ENTERED: 'Entered',
    EPCS_ERROR: 'EpcsError',
    EPCS_SIGNED: 'EpcsSigned',
    PHARMACY_VERIFIED: 'PharmacyVerified'
}

export const CONTROLLED_SUBSTANCE_SCHEDULES = {
    SCHEDULE_I: '1',
    SCHEDULE_II: '2',
    SCHEDULE_III: '3',
    SCHEDULE_IV: '4',
    SCHEDULE_V: '5',
    NON_CONTROLLED: '0'
}

export const PRESCRIPTION_ACTIONS = {
    RESEND: 'resend',
    DELETE: 'delete',
    CANCEL: 'cancel'
}

export const MODAL_MODES = {
    ADD: 'add',
    EDIT: 'edit'
}

export const DEFAULTS = {
    PIN_LENGTH: 4,
    OTP_LENGTH: 6,
    DEBOUNCE_DELAY: 300,
    MODAL_WIDTH: 900,
    GRID_COLUMNS: '65% 35%'
}

export const LAB_RESOURCE_TYPE = {
    REPORT: 'report',
    ORDER: 'order'
}

export const TELEMEDICINE_CATEGORIES = {
    TESTOSTERONE: {
        name: 'testosterone',
        categoryId: '66154b471d36a7fe42f19d61'
    },
    SERMORELIN: {
        name: 'sermorelin',
		categoryId: '688bb3eaa041b8b948f98b52'
    }
}

export const CaseActions = {
    ARCHIVE: 'archive',
    RESTORE: 'restore',
    DELETE: 'delete',
    RELEASE: 'release',
    REASSIGN: 'reassign',
    UPDATE_STATUS: 'update status',
    CONSULTATION_TYPE: 'consultationType',
    EXPORT: 'export'
  }

export const STATUS_TYPE = {
	CASE: 'case',
	REQUEST: 'request',
	PRESCRIPTION: 'prescription'
}
